import { updateCacheData } from 'utils/commonFunctions';

import { createApiInstance } from './createApiInstance';

const extendedApi = createApiInstance.injectEndpoints({
  endpoints: (build) => ({
    getExternalUserRegisterStatus: build.query({
      query: () => '/coohom/external-user-register',
    }),
    getUserCoohomProject: build.query({
      query: () => '/coohom/get-user-projects',
    }),
    syncProjectsWithBaru: build.mutation({
      query: (body) => {
        return {
          url: '/coohom/sync-projects-with-baru',
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['UpdateProjects', 'FetchAllProjects'],
      async onQueryStarted(patch, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          updateCacheData(
            {
              state: getState(),
              method: 'getUserProjects',
              dispatch,
              extendedApi,
            },
            (draft) => {
              return {
                ...draft,
                ...data?.data,
              };
            }
          );
        } catch (error) {
          console.error(error);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetExternalUserRegisterStatusQuery,
  useSyncProjectsWithBaruMutation,
  useGetUserCoohomProjectQuery,
} = extendedApi;
